import { Injectable, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ElementRow } from './treelist.model';

@Injectable()
export class TreelistEventService {

  private selectElementSource = new Subject<ElementRow>();

  public selectElement$ = this.selectElementSource.asObservable();

  public announceSelect(selectedElement: ElementRow){
    this.selectElementSource.next(selectedElement);
  }
  
}
